<template>
  <div :style="styles.base">
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <c-dialog v-model="isShow" :option="option"
                   @close="closeBtnClick"
                   @confirm="closeBtnClick"
                   v-transfer-dom>
      <template slot="body">
        <div :class="getCss('reward')" v-if="!showDefaultGiftReceivePopText">
          <!-- <div>恭喜你获得了</div> -->
          <!-- <div v-for="(item,index) in packageNames" :key="index">{{ item }}</div> -->
          <div>{{ packageNames }}</div>
        </div>
        <div :class="getCss('reward')" :style="defaultGiftStyle" v-else>
          <div>{{ defaultGiftReceivePopText }}</div>
        </div>
      </template>
      <template slot="footer">
        <div v-if="checkGiftType('packageRealGift')" :style="actionStyle">
          <button
            class="ceiba-dialog-ft-button"
            :style="inputAddressStyle"
            @click="signAddress"
          >
          </button>
          <div :class="getCss('address-tips')">提示：实物奖励需填写地址才可以收到</div>
        </div>
        <div v-if="checkGiftType('cdk')" :style="actionStyle">
          <p :class="getCss('cdk-tips')">CDK: {{ CDKeyValue }}</p>
          <div :style="actionStyle" :class="getCss('cdk-action-button')">
            <button
              class="ceiba-dialog-ft-button"
              :style="copyStyle"
              @click="copyCDkText"
            >
            </button>
            <button
              class="ceiba-dialog-ft-button"
              :style="downloadGameButtonStyle"
              @click="startCallDownload"
            >
            </button>
          </div>

        </div>
        <div v-if="checkGiftType('cash')" :style="actionStyle">
          <button
            class="ceiba-dialog-ft-button"
            :style="cashStyle"
            @click="bindWx"
          >
          </button>
          <div :class="getCss('address-tips')">{{ packageCashInputText }}</div>
        </div>
        <!-- 领取红包 -->
        <div v-if="checkGiftType('redPacket')" :style="actionStyle">
          <button
            class="ceiba-dialog-ft-button"
            :style="redPacketStyle"
            @click="rewardRedPacket()"
          >
          </button>
          <div :class="getCss('address-tips')">{{ packageRedPacketInputText }}</div>
        </div>
      </template>
    </c-dialog>

    <c-dialog v-model="isShowGift" :option="giftOption"
                   @close="closeBtnClick"
                   @confirm="closeBtnClick"
                   v-transfer-dom>
      <template slot="body">
        <div :class="getCss('isShowGift-body')" v-if="giftPopIconMap.length > 1">
          <div v-for="(v,key) in giftPopIconMap" :key="key" :class="getCss('isShowGift-div')">
            <div :class="getCss('isShowGift-div-img')">
              <img :src="v.icon" :class="getCss('isShowGift-img')">
            </div>
            <div :class="getCss('isShowGift-div-text')">
              <p >{{ v.packageName.substr(0,4) }} <span v-if="v.packageName.length > 5">...</span></p>
            </div>
          </div>
        </div>
        <div v-else :class="getCss('isShowGift-body-one')">
            <div v-for="(v,key) in giftPopIconMap" :key="key" :class="getCss('isShowGift-div-one')">
              <div :class="getCss('isShowGift-div-img-one')">
                <img :src="v.icon" :class="getCss('isShowGift-img-one')">
              </div>
              <div :class="getCss('isShowGift-div-text-one')">
                {{ v.packageName }}
              </div>
            </div>
        </div>
      </template>
      <template slot="footer">
        <div v-if="checkGiftType('packageRealGift')" :style="actionStyle">
          <button
            class="ceiba-dialog-ft-button"
            :style="inputAddressStyle"
            @click="signAddress"
          >
          </button>
          <div :class="getCss('address-tips')">提示：实物奖励需填写地址才可以收到</div>
        </div>
        <div v-if="checkGiftType('cdk')" :style="actionStyle">
          <p :class="getCss('cdk-tips')">CDK: {{ CDKeyValue }}</p>
          <div :style="actionStyle" :class="getCss('cdk-action-button')">
            <button
              class="ceiba-dialog-ft-button"
              :style="copyStyle"
              @click="copyCDkText"
            >
            </button>
            <button
              class="ceiba-dialog-ft-button"
              :style="downloadGameButtonStyle"
              @click="startCallDownload"
            >
            </button>
          </div>

        </div>
        <div v-if="checkGiftType('cash')" :style="actionStyle">
          <button
            class="ceiba-dialog-ft-button"
            :style="cashStyle"
            @click="bindWx"
          >
          </button>
          <div :class="getCss('address-tips')">{{ this.packageCashInputText }}</div>
        </div>
        <!-- 领取红报 -->
        <div v-if="checkGiftType('redPacket')" :style="actionStyle">
          <button
            class="ceiba-dialog-ft-button"
            :style="redPacketStyle"
            @click="rewardRedPacket()"
          >
          </button>
          <div :class="getCss('address-tips')">{{ packageRedPacketInputText }}</div>
        </div>
      </template>
    </c-dialog>
    <c-public-reward-box v-bind="$props" ref="rewardBox"></c-public-reward-box>
    <div v-transfer-dom>
      <div
        v-show="isDoLottery"
        :class="getCss('lottery-masking')"
      ></div>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, baseComponents } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/ceiba-dialog';
import CPublicRewardBox from '@tencent/ceiba-act-public-reward-box';
export default {
  name: 'CButtonLottery',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
    [CPublicRewardBox.name]: CPublicRewardBox,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'button-lottery-',
      isReachMaximumLimit: false,
      packageName: '内测资格',
      isShow: false,
      isOpenDownload: true,
      CDKeyValue: '',
      copyCdkIconImage: 'https://game.gtimg.cn/images/js/img/tgclub/copyCDk.png',
      downloadGameIconImage: 'https://game.gtimg.cn/images/js/img/tgclub/downloadInit.png',
      packageRealGiftInputIcon: 'https://game.gtimg.cn/images/js/img/tgclub/downloadInit.png',
      copyCdkSuccessTrips: '',
      packageCashInputIcon: '',
      packageCashInputText: '',
      packageId: 0,
      giftMap: [], // 抽奖道具icon
      isShowGift: false, // 道具icon弹窗
      giftPopIconMap: [], // 抽中的道具
      redirectTrips: '', // cdk跳转提示文案
      redirectUrl: '', // cdk跳转链接
      packageRedPacketInputIcon: '', // 领取红包按钮icon
      packageRedPacketInputText: '', // 领取红包成功提示
      sSerialId: '', // 流水id
      headerText: '恭喜获得',
      isDoLottery: false, // 是否正在抽奖
    };
  },
  computed: {
    actionStyle() {
      return {
        width: this.dialogConfig.width,
      };
    },
    option() {
      return Object.assign({}, this.dialogConfig, {
        footer: true,
        close: true,
        header: this.headerText,
        cancel: false,
        confirm: !!this.dialogConfig?.confirmStyle?.backgroundImage,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    giftOption() {
      return Object.assign({}, this.dialogConfig, {
        footer: true,
        close: true,
        header: '恭喜获得',
        cancel: false,
        confirm: !!this.dialogConfig?.confirmStyle?.backgroundImage,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    computedStyle() {
      const { isStretching } = this.configurationData;
      return {
        backgroundImage: `url(${this.configurationData.rewardImg})`,
        backgroundSize: isStretching ? '' : 'contain', // 是否拉伸
        backgroundRepeat: 'no-repeat',
        left: 0,
        top: 0,
        position: 'static',
      };
    },
    inputAddressStyle() {
      return {
        display: 'block',
        backgroundImage: `url(${this.packageRealGiftInputIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',

        margin: '0 auto',
      };
    },
    copyStyle() {
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundImage: `url(${this.copyCdkIconImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    defaultGiftStyle() {
      return {
        fontSize: '0.22rem',
      };
    },
    cashStyle() {
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundImage: `url(${this.packageCashInputIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        // backgroundSize:'100% 100%',
        margin: '0 auto',
      };
    },
    redPacketStyle() {
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundImage: `url(${this.packageRedPacketInputIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        // backgroundSize:'100% 100%',
        margin: '0 auto',
      };
    },
    downloadGameButtonStyle() {
      return {
        width: '2.2rem',
        height: '0.65rem',
        display: this.isOpenDownload ? 'block' : 'none',
        backgroundImage: `url(${this.downloadGameIconImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    enable() {
      const packageStatus = this.quaInfo[this.configurationData.flowID];
      if (!packageStatus) return false;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    packageNames() {
      // 换行展示改成单行展示
      // return this.packageName ? this.packageName.split(',') : '';
      return this.packageName || '';
    },
    // 设置默认礼包id
    defaultPackageId() {
      const { defaultPackageId = 0 } = this.configurationData;
      return parseInt(defaultPackageId, 10);
    },
    // 抽中默认礼包弹框文案
    defaultGiftReceivePopText() {
      return this.configurationData?.defaultGiftReceivePopText || '';
    },
    // 是否显示默认礼包文案
    showDefaultGiftReceivePopText() {
      return this.defaultPackageId > 0 && this.defaultPackageId === this.packageId && this.defaultGiftReceivePopText;
    },
    // 修改弹窗内容上间距
    marginTopOfTc() {
      const marginTopHeight = this.dialogConfig?.height.replace('px', '').replace('rem', '');
      const intHeight = parseInt(marginTopHeight, 10);
      const topNum = 5 - (intHeight - 5);
      return topNum;
    },
  },
  watch: {
    // 动态监视领取到礼包的变化，当礼包id 等于配置的默认礼包 且 有默认礼包弹框文案时，修改标题显示
    packageId(val) {
      if (val && parseInt(val, 10) === parseInt(this.defaultPackageId, 10) && this.defaultGiftReceivePopText) {
        this.headerText = '温馨提示';
      } else {
        this.headerText = '恭喜获得';
      }
    },
  },
  mounted() {
    console.log('configurationData=', this.configurationData);
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.$isInEditor) return;
      this.$refs.button.setClickHandler(this.doReward, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: this.actInfo.extendConfig.forceRole,
      });
      if (this.configurationData.openGiftPop) {
        this.configurationData.giftIconList.forEach((item) => {
          const itemStrArr = String(item.packageId).split(',');
          itemStrArr.forEach((value) => {
            const itemArr = {};
            itemArr.packageId = value;
            itemArr.icon = item.icon;
            this.giftMap.push(itemArr);
          });
        });
      } else {
        this.giftMap = this.configurationData.iconList;
      }
    },
    closeBtnClick() {
      this.isShow = false;
      this.isShowGift = false;
      if (this.configurationData?.showPagEvent) {
        this.$eventBus.$emit('ceiba:common:events:commercial:money:box:anime', { varying: this.configurationData?.showPagEvent });
      }
    },
    initValue() {
      this.copyCdkSuccessTrips = '';
      this.copyCdkIconImage = '';
      this.downloadGameIconImage = '';
      this.isOpenDownload = false;
      this.packageRealGiftInputIcon = '';
      this.packageCashInputIcon = '';
      this.packageCashInputText = '';
      this.packageRedPacketInputIcon = '';
      this.packageRedPacketInputText = '';
    },
    checkGiftType(checkType) {
      const { packageId } = this;
      if (packageId === 0 || !packageId) return false;
      const receiveGiftCustomConfig = this.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];
      const res = receiveGiftCustomConfig?.find(item => String(packageId).includes(item.gift_id));
      const { type = '' } = res || {};
      if (type === 'cdk' && checkType === 'cdk') {
        this.copyCdkSuccessTrips = res?.playload?.copyCdkSuccessTrips ?? '复制成功';
        this.copyCdkIconImage = res?.playload?.copyCdkIconImage ?? '';
        this.downloadGameIconImage = res?.playload?.downloadGameIconImage ?? '';
        this.isOpenDownload = parseInt(res?.playload?.isOpenDownload ?? 1, 10) === 2;

        this.redirectTrips = res?.playload?.redirectTrips ?? '立即前往兑换权益';
        this.redirectUrl = res?.playload?.redirectUrl ?? '';
        return true;
      }
      if (type === 'packageRealGift' && checkType === 'packageRealGift') {
        this.packageRealGiftInputIcon = res?.playload?.packageRealGiftInputIcon ?? '';
        return true;
      }
      if (type === 'cash' && checkType === 'cash') {
        this.packageCashInputIcon = res?.playload?.packageCashInputIcon ?? '';
        this.packageCashInputText = res?.playload?.packageCashInputText ?? '';
        return true;
      }
      if (type === 'redPacket' && checkType === 'redPacket') {
        this.packageRedPacketInputIcon = res?.playload?.packageRedPacketInputIcon ?? '';
        this.packageRedPacketInputText = res?.playload?.packageRedPacketInputText ?? '';
        return true;
      }
      // todo 实现多个类型判断
      // if (type === 'privateQualification' ){
      //   this.link = res?.playload?.link ?? '';
      //   this.surveyTrip = res?.playload?.trips ?? '点击"确定"跳转填写问卷';
      //   console.log('isShowSurvey', true, this.link, this.surveyTrip);
      //   return  true;
      // }
      return false;
    },
    async signAddress() {
      console.log('signAddress');
      this.isShow = false;
      this.$eventBus.$emit('ceiba:common:events:address-fill', {});
    },
    bindWx() {
      this.isShow = false;
      this.$eventBus.$emit('ceiba:common:event:account-wx-qq-fill', { bindType: 'wx' });
    },
    startCallDownload() {
      this.$eventBus.$emit('ceiba:common:events:call-game-download', {});
    },
    copyCDkText() {
      const textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      textarea.style.position = 'fixed';
      textarea.style.clip = 'rect(0 0 0 0)';
      textarea.style.top = '10px';
      textarea.value = this.CDKeyValue;
      textarea.select();
      document.execCommand('copy', true);
      document.body.removeChild(textarea);
      if (this.redirectUrl !== '') {
        const that = this;
        this.alert({ msg: this.redirectTrips, confirm() {
          window.location.href = that.redirectUrl;
        } });
      } else {
        this.$toast(this.copyCdkSuccessTrips || '复制cdk成功');
      }
      return true;
    },
    reportFunc(status, giftId) {
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'lottery',
        eventData: {
          gift_id: giftId,
          status,
        },
      });
    },
    hideLotteryMasking() {
      const that = this;
      setTimeout(() => {
        that.isDoLottery = false;
      }, 3000);
    },
    async doReward() {
      this.handleClickEvent();
      this.isDoLottery = true;
      this.giftPopIconMap = [];
      this.sSerialId = '';
      console.log('this.isDoLottery', this.isDoLottery);
      await this.doHook({
        name: 'click_reward',
        options: {
          meta: this.meta,
          configurationData: this.configurationData,
          reportPv: this.pageInfo.canvasConfig.reportPv,
        },
      });
      let lotteryNums = 0;
      if (this.configurationData?.queryLotteryNumFlowId) {
        const lotteryNumResponse = await this.flowRequest({
          flowId: this.configurationData.queryLotteryNumFlowId,
        });
        lotteryNums = lotteryNumResponse?.data?.useNum || lotteryNumResponse?.data?.remain;
      }
      this.packageName = ''; // 置空
      // if (!this.enable) {
      //   this.alert(this.configurationData.remainTips || '抽奖资格不足');
      //   return;
      // }
      if (!(await this.doHook({ name: 'before_reward' }))) {
        return;
      }
      const totalParams = {
        flowId: this.configurationData.flowID,
        params: {
          role: this.configurationData.needRole ? this.roleInfo : {},
        },
        options: {
          carryRoleFlag: true,
        },
      };
      const  { forbiddenRequireRole = false } =  this.configurationData;
      // 禁止强制传角色
      if  (forbiddenRequireRole === true) {
        totalParams.params.role = {};
        totalParams.options.carryRoleFlag = false;
      }
      // costTimes 抽奖次数 用于gbot特定接口进行传参
      let  { costTimes = 0 } = this.configurationData;
      costTimes = parseInt(costTimes, 10) || 0;
      if  (costTimes > 0) {
        totalParams.params.data = {};
        totalParams.params.data = JSON.stringify({ costTimes, pNum: costTimes });
      }
      let response = await this.flowRequest(totalParams);
      response = this.$refs.rewardBox.handlerLotteryModeResponse(response);
      console.log('【CCommercialRepeatedlyLottery】doReward response = ', response);
      // const response = {
      //   ret: 0,
      //   msg: '恭喜您获得了礼包： 高级藏宝图*1 ',
      //   data: {
      //     ret: 0,
      //     msg: '恭喜您获得了礼包： 高级藏宝图*1 ',
      //     gifts: [
      //       {
      //         package_id: '4029135',
      //         num: 1,
      //         real_flag: '0',
      //       },
      //     ],
      //     packageName: '恭喜您获得了礼包：高级藏宝图*1',
      //     package_name: '恭喜您获得了礼包：高级藏宝图*1',
      //     packageId: '111',
      //   },
      //   serialId: 'ceiba-supercore-12969-80799-1682326511809-68b84c94-0',
      // };
      await this.refreshQua(); // 刷新礼包
      await this.doHook({
        name: 'after_reward',
        options: {
          meta: this.meta,
          configurationData: this.configurationData,
          reportPv: this.pageInfo.canvasConfig.reportPv,
          response,
        },
      }); // 后置动作，上报等

      const { ret: rspRet, msg: rspMsg, data = {} } = response;
      // 第一层报错
      if (rspRet !== 0) {
        this.isDoLottery = false;
        this.reportFunc('0', '');
        return this.alert(rspMsg);
      }

      const { ret, package_id = '0', packageId: otherPackageId = '0', msg, package_cdkey: cdkey } = data;
      this.packageId = parseInt(package_id, 10) || parseInt(otherPackageId, 10) || 0;
      // 当获得多个礼包id时候
      if (package_id.includes(',')) {
        this.packageId = package_id;
      }
      // 什么都没有领取成功
      // 第二层报错
      if (ret !== 0 || this.packageId === 0) {
        this.isDoLottery = false;
        this.reportFunc('0', '');
        return this.alert(msg);
      }
      this.reportFunc('1', package_id || '');
      if (this.configurationData?.lotteryPlayType === 'lucky') {
        await this.showNewPop(response, lotteryNums);
      } else {
        this.isDoLottery = false;
        this.packageName = response.data.msg.replace('恭喜您获得了礼包：', '');
        this.packageName = this.packageName.replace(' ', '');
        this.CDKeyValue = cdkey;
        this.sSerialId = response?.data?.req_serial;
        this.initValue();
        if (this.configurationData.openGiftPop) {
          console.log('response.data', response.data);
          const packageNameArr = response.data.package_name.split(',');
          const packageIdArr = response.data.package_id.split(',');
          packageIdArr.forEach((pakageIdItem, key) => {
            const pakageIdItemArr = pakageIdItem.split(':');
            let forIndex = 1;
            if (pakageIdItemArr.length > 1) {
              forIndex = parseInt(pakageIdItemArr[1], 10);
            }
            const newItemArr = {};
            const newGiftIconArr = this.giftMap.filter(item => parseInt(item.packageId, 10)
              === parseInt(pakageIdItemArr[0], 10));
            for (let i = 0; i < forIndex; i++) {
              newItemArr.packageId = parseInt(pakageIdItemArr[0], 10);
              newItemArr.packageName = packageNameArr[key];
              newItemArr.icon = newGiftIconArr[0].icon;
              this.giftPopIconMap.push(newItemArr);
            }
          });
          this.isShowGift = true;
        } else {
          if (this.configurationData.showGiftIcon) { // 如果showGiftIcon为true,弹图片弹窗
            baseComponents.GiftComponent.showGiftDialog({
              meta: {
                packageInfo: response.data,
                iconList: this.configurationData.iconList,
              },
              option: Object.assign({}, this.dialogConfig, {
                dialogStyle: this.dialogConfig?.dialogStyle || {
                  color: '#282121',
                },
              }),
            });
          } else {
            // 处理 msg 和 ams_code_msg 返回数据不统一问题，优先考虑字符长的字段 start
            const packageIdStr = response?.data?.package_id || response?.data?.packageId;
            const packageNameStrArr = response?.data?.package_name?.split(',');
            const packageNumStrArr = packageIdStr?.split(',');
            const newPackageNameArr = [];
            for (let i = 0; i < packageNumStrArr?.length; i++) {
              const newNumArr = packageNumStrArr?.[i]?.split(':');
              const lsPackageNum = parseInt(newNumArr?.[1], 10);
              // 当返回的礼包数量大于 1 个时
              if (newNumArr?.length > 1) {
                const lsStr = `${packageNameStrArr?.[i]} ${lsPackageNum}个`;
                newPackageNameArr.push(lsStr);
              } else {
                newPackageNameArr.push(packageNameStrArr?.[i]);
              }
            }
            this.packageName = newPackageNameArr.join(',');
            // 处理 msg 和 ams_code_msg 返回数据不统一问题，优先考虑字符长的字段 end
            this.isShow = true;
          }
        }
      }
    },
    /**
     * 调用欧皇新弹窗
     * @param responseData
     * @returns {Promise<void>}
     */
    async showNewPop(responseData, nums) {
      const iconArr = {
        packageConfig: {},
        displayConfig: {},
      };
      let headerText = '恭喜获得';
      let ripsText = '';
      if (parseInt(responseData.data.package_id, 10)
        === parseInt(this.configurationData?.displayConfig?.defaultGiftId, 10)) {
        headerText = '温馨提示';
        ripsText = this.configurationData?.ripsText;
      }
      this.$set(iconArr, 'packageConfig', this.configurationData.giftIconList);
      this.$set(iconArr.displayConfig, 'lotteryPlayType', this.configurationData.lotteryPlayType);
      this.$set(iconArr.displayConfig, 'headerText', headerText);
      this.$set(iconArr.displayConfig, 'ripsText', ripsText);
      this.$set(iconArr.displayConfig, 'lotteryNum', nums);
      const metaData = this.$refs.rewardBox.buildMetaData(iconArr, responseData);
      this.isDoLottery = false;
      console.log(metaData);
      this.$refs.rewardBox.showPop(metaData);
    },
    // 领取红包 调用引导绑定姓名组件内的领取礼包流程
    rewardRedPacket() {
      const { packageId, sSerialId } = this;
      this.$eventBus.$emit('ceiba:common:events:rewardRedPacket', {
        gift_id: packageId,
        req_serial: sSerialId,
      });
      this.isShow = false;
      this.isShowGift = false;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
